import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NbDialogRef, NB_THEME_OPTIONS } from "@nebular/theme";

import { ModalConfirmationService } from "../confirmation-modal/confirmation-modal.service";
import { UserService } from "../../user.service";
import { NgForm } from "@angular/forms";

import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import { SalesOrderService } from "../../sales-order.service";
import { ConfigurationService } from "../../configuration.service";
import { getCurrencySymbol } from "@angular/common";
import { ToastService } from "../../toast.service";

@Component({
  templateUrl: "./create-sales-order.html",
  styles: [
    `
      ::ng-deep .ng-dropdown-panel.inModal {
        z-index: 1060 !important;
      }
    `,
  ],
})
export class CreateSalesOrderModalComponent implements OnInit {
  @Input() public salesOrderUUID;
  @ViewChild("createSalesOrder") public createSalesOrderForm: NgForm;
  public loaded = false;
  public salesOrder = {
    salesOrderUUID: null,
    insurgoOrderNumber: null,
    customerOrderNumber: null,
    customerID: null,
    deliveryCost: 0,
    deliveryCurrency:
      this.configurationService.getConfigurationSettings().defaultCurrency,
    status: null,
    orderDateSec: null,
  };

  public currencySymbol: string = getCurrencySymbol(
    this.salesOrder.deliveryCurrency,
    "narrow"
  );

  public formError: any = {
    submitting: false,
    error: false,
    success: false,
  };
  private originalData: Object;

  constructor(
    protected ref: NbDialogRef<CreateSalesOrderModalComponent>,
    private _modalConfirmationService: ModalConfirmationService,
    private _salesOrderService: SalesOrderService,
    private toastService: ToastService,
    private configurationService: ConfigurationService
  ) {}

  async ngOnInit() {
    this.originalData = this.deepCopy(<Object>this.salesOrder);
    if (this.salesOrderUUID) {
      await this.getData();
    } else {
      this.loaded = true;
    }
  }

  public submit(): void {
    // set some realistic defaults
    this.formError.submitting = true;
    this.formError.success = false;
    this.formError.error = false;
    if (this.salesOrderUUID) {
      this._salesOrderService
        .updateSalesOrder(this.salesOrderUUID, this.salesOrder)
        .subscribe(
          (response) => {
            this.formError.success = true;
            setTimeout(
              function () {
                this.toastService.showToast(
                  "success",
                  "Sales Order Edited",
                  `Sales Order ${this.salesOrder.insurgoOrderNumber} was edited successfully!`
                );
                this.ref.close(true);
              }.bind(this),
              3000
            );
          },
          (err) => {
            this.toastService.showToast(
              "error",
              "Error",
              err
            );
            this.formError.error = true;
            setTimeout(
              function () {
                this.formError.submitting = false;
              }.bind(this),
              3000
            );
          }
        );
    } else {
      this._salesOrderService.createSalesOrder(this.salesOrder).subscribe(
        (response) => {
          this.formError.success = true;
          setTimeout(
            function () {
              this.toastService.showToast(
                "success",
                "Sales Order Created",
                `A new sales order was created successfully!`
              );
              this.ref.close(true);
            }.bind(this),
            3000
          );
        },
        (err) => {
          this.toastService.showToast(
            "error",
            "Error",
            err
          );
          this.formError.error = true;
          setTimeout(
            function () {
              this.formError.submitting = false;
            }.bind(this),
            3000
          );
        }
      );
    }
  }

  public async cancel(dirty) {
    if (dirty) {
      const result = await this._modalConfirmationService.confirm(
        "Still Editing the form?",
        "You have not finished editing, are you sure you want to cancel?"
      );
      if (result === "confirm") {
        this.ref.close(false);
      } else if (result === "cancel") {
      } else if (result === "decline") {
      }
    } else {
      this.ref.close(false);
    }
  }

  public displayFieldCss(form: NgForm, field: any) {
    if (form.dirty) {
      if (field.touched && field.invalid) {
        //invalid
        return "danger";
      } else if (field.valid) {
        //valid
        return "success";
      } else {
        //needs to be filled in
        return "warning";
      }
    } else {
      return "basic";
    }
  }
  public formatDeliveryCost() {
    const val = this.salesOrder.deliveryCost;
    if (val != null && !isNaN(val)) {
      this.salesOrder.deliveryCost = parseFloat(val.toFixed(2));
    }
  }

  private deepCopy(obj): any {
    let copy;
    // Handle the 3 simple types, and null or undefined
    if (obj == undefined || typeof obj !== "object") {
      return obj;
    }
    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());

      return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.deepCopy(obj[i]);
      }

      return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (const attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          copy[attr] = this.deepCopy(<Object>obj[attr]);
        }
      }

      return copy;
    }
    throw new Error(`Unable to copy obj! Its type isn't supported.`);
  }
  private async getData() {
    try {
      this.loaded = false;
      let data = <any>(
        await this._salesOrderService
          .getSalesOrderByID(this.salesOrderUUID)
          .toPromise()
      );
      this.salesOrder = this.deepCopy(data);
      this.originalData = this.deepCopy(data);
      this.currencySymbol = getCurrencySymbol(
        this.salesOrder.deliveryCurrency,
        "narrow"
      );
      this.loaded = true;
    } catch (error) {
      this.toastService.showToast(
        "error",
        "Fetch Error",
        `Error occurred getting the sales order data!`
      );
      this.ref.close(false);
    }
  }
  private _markFormPristine(): void {
    const {
      createSalesOrderForm: { value: formValueSnap },
    } = this; // const formValueSnap = this.myForm.value;
    this.createSalesOrderForm.reset(formValueSnap);
    Object.keys(this.createSalesOrderForm.controls).forEach((control) => {
      this.createSalesOrderForm.controls[control].markAsPristine();
      this.createSalesOrderForm.controls[control].markAsUntouched();
    });
  }

  private reset(form: NgForm) {
    this.salesOrder = this.deepCopy(<Object>this.originalData);
    this.formError.submitting = false;
    this.formError.success = false;
    setTimeout(
      function () {
        this._markFormPristine();
      }.bind(this),
      500
    );
  }
}
